import axios from 'axios'
import {API_URL} from '../../../../../../_metronic/helpers'
import type {InvoiceProformaInfo} from './invoiceProforma'

const PROFORMA_URL = `${API_URL}/invoices/proforma`

export type ProformaConversionRequest = {
  /** Jalali with time (1405/07/21 10:30); the server's now when empty. */
  date?: string
  /** The invoice number; the next number of the invoice line when empty. */
  no?: string
  /** Required: a proforma has no fiscal memory; the invoice is issued with the one chosen here. */
  fiscalMemoryId: number
}

export type ProformaConversionResult = {
  invoiceHash: string
  invoiceNo: string
  proformaHash: string
}

export type ProformaSettings = {
  defaultValidityDays: number
  isProductDefault: boolean
  minimumValidityDays: number
  maximumValidityDays: number
  canChange: boolean
}

/** «تبدیل به صورتحساب»: registers a new invoice from an open proforma. */
export const convertProforma = (hash: string, request: ProformaConversionRequest) =>
  axios
    .post(`${PROFORMA_URL}/${encodeURIComponent(hash)}/convert`, request)
    .then((response) => response.data?.data as ProformaConversionResult)

export type ProformaCopyResult = {
  proformaHash: string
  proformaNo: string
  sourceHash: string
}

/**
 * «کپی به پیش‌فاکتور جدید»: a new open proforma with this one's buyer, items and terms, the next
 * proforma number, today's date and the business's default validity. This one does not change.
 */
export const copyProforma = (hash: string) =>
  axios
    .post(`${PROFORMA_URL}/${encodeURIComponent(hash)}/copy`)
    .then((response) => response.data?.data as ProformaCopyResult)

/** «تمدید اعتبار»: moves the proforma's last valid day later. */
export const extendProformaValidity = (hash: string, validUntil: string) =>
  axios
    .post(`${PROFORMA_URL}/${encodeURIComponent(hash)}/validity`, {validUntil})
    .then((response) => response.data?.data as InvoiceProformaInfo)

export const getProformaSettingsQueryKey = (companyId: number) =>
  ['invoice-proforma-settings', companyId] as const

/** A business's proforma settings; the selected business's when companyId is not given. */
export const getProformaSettings = (companyId?: number) =>
  axios
    .get(`${PROFORMA_URL}/settings`, {params: companyId ? {companyId} : undefined})
    .then((response) => response.data?.data as ProformaSettings)

export const saveProformaSettings = (companyId: number, defaultValidityDays: number) =>
  axios
    .post(`${PROFORMA_URL}/settings`, {companyId, defaultValidityDays})
    .then((response) => response.data?.data as ProformaSettings)

/** The next number of a numbering line: proformas and invoices are numbered separately. */
export const getNextDocumentNumber = (proforma: boolean) =>
  axios
    .get(`${API_URL}/invoices/checkNo/`, {params: proforma ? {proforma: true} : undefined})
    .then((response) => String(response.data ?? ''))
